import { AppDescription, SerializedApp } from "../components/SerializedApp";
import { AppEnvironment } from "../components/types";
import { BuilderActionsForApp } from "../Database/builder-actions";
import { BuilderAppBuilder } from "./builder";
import { makeSimpleAppDescriptionContext } from "./components";
import { TypeSchema } from "./description";

export function buildSerializedApp(
    appEnvironment: AppEnvironment,
    schema: TypeSchema,
    appDesc: AppDescription,
    builderActions: BuilderActionsForApp
): SerializedApp {
    let { appFeatures } = appEnvironment;
    // FIXME: This is a terrible hack.  I'm not sure why we take the app feature from the app
    // environment in the first place, but I'm afraid that we'll break something if we don't.
    if (appDesc.features !== undefined) {
        appFeatures = {
            ...appFeatures,
            automaticRefreshMinutes: appDesc.features.automaticRefreshMinutes,
            googleAnalyticsMeasureIDs: appDesc.features.googleAnalyticsMeasureIDs,
            showSignInWithGoogle: appDesc.features.showSignInWithGoogle,
            enableShareScreen: appDesc.features.enableShareScreen,
            disableSharing: appDesc.features.disableSharing,
            shareScreenTitle: appDesc.features.shareScreenTitle,
        };
    }
    const adc = makeSimpleAppDescriptionContext(appEnvironment.appID, appDesc, builderActions, schema);
    const appBuilder = new BuilderAppBuilder(adc, appFeatures, appEnvironment.eminenceFlags);
    return appBuilder.buildApp();
}
